// extracted by mini-css-extract-plugin
export default {"coverLink":"LR-z","contentBox":"MR-z","zapposPromoContainer":"NR-z","zapposPromoGroupContainer":"OR-z","promos":"PR-z","bottom":"QR-z","top":"RR-z","right":"SR-z","left":"TR-z"};